import { render, staticRenderFns } from "./courier-list.vue?vue&type=template&id=9c67d56a&"
import script from "./courier-list.vue?vue&type=script&lang=js&"
export * from "./courier-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports